<div *ngIf="serverResponse()" class="row">
  <div class="col-12">
    <app-server-response [response]="serverResponse()"></app-server-response>
  </div>
</div>
<div class="mb-4 mt-4">
  <div class="card-header" style="border: 1px solid #e4e4e4;">
    <h2 class="text-center m-0">{{ "CASES.single.settlements.title" | translate }}</h2>
  </div>
  <div class="card-body p-0">
    <div class="mat-elevation-z5" style="border: 1px solid rgba(0, 0, 0, 0.12); border-top: none">
      <table style="width: 100%" mat-table [dataSource]="dataSource()">

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>{{ "CASES.single.date" | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.created_at | toDateObject | date }}</td>
        </ng-container>

        <ng-container matColumnDef="creditor">
          <th mat-header-cell *matHeaderCellDef>{{ "CASES.single.settlements.creditor" | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.case_creditor?.creditor?.name ?? '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="debt_amount">
          <th mat-header-cell *matHeaderCellDef>{{ "CASES.single.settlements.debt_amount" | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.debt_amount | currency: 'EUR' }}</td>
        </ng-container>

        <ng-container matColumnDef="settled_amount">
          <th mat-header-cell *matHeaderCellDef>{{ "CASES.single.settlements.settled_amount" | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.settled_amount | currency: 'EUR' }}</td>
        </ng-container>

        <ng-container matColumnDef="percent_reduction">
          <th mat-header-cell *matHeaderCellDef>{{ "CASES.single.settlements.percent_reduction" | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.case_creditor?.percent_reduction ?? '-' }}%</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <div *ngIf="isLoading()" class="text-center" style="padding: 50px">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div *ngIf="!isLoading() && !hasData()">
        <h3 class="text-center pt-3">{{ "CASES.single.settlements.no_data" | translate }}</h3>
      </div>

      <mat-paginator [length]="paginatorConfig().length"
                     [pageSize]="paginatorConfig().pageSize"
                     [pageSizeOptions]="[5, 10, 20]"
                     (page)="paginatorChange($event)"
                     showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</div>
